import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { setLanguage, selectAvailableLanguages, selectCurrentLanguage } from '@/entities/language';
import { useAppDispatch, useAppSelector } from '@/shared/lib';
import { updateDirection } from '@/i18n';

import { CountryFlag } from '../country-flag';

function LanguageSelector() {
  const { i18n, t } = useTranslation();
  const dispatch = useAppDispatch();

  const availableLanguages = useAppSelector(selectAvailableLanguages);
  const currentLanguage = useAppSelector(selectCurrentLanguage);

  const handleLanguageChange = useCallback(
    (lang: string) => {
      i18n.changeLanguage(lang);
      dispatch(setLanguage(lang));
      updateDirection(lang);
    },
    [i18n, dispatch]
  );

  return (
    <Select value={currentLanguage} onValueChange={handleLanguageChange}>
      <SelectTrigger className="w-[140px] h-9 bg-background border-border">
        <SelectValue placeholder={t('language.select')} />
      </SelectTrigger>
      <SelectContent>
        {availableLanguages.map((lang) => (
          <SelectItem key={lang.code} value={lang.code}>
            <span className="flex items-center gap-2">
              <CountryFlag country={lang.country} />
              <span>{lang.label}</span>
            </span>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}

export default LanguageSelector;
